import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// FIGYELEM: ha a LoadingPage nálad nem a pages mappában van, itt írd át az útvonalat.
import LoadingPage from '../pages/LoadingPage';

/**
 * Oldalváltáskor a töltőképernyő AZONNAL (ugyanabban a renderben) eltakarja a régi oldalt,
 * az új oldal csak a késleltetés után kerül be mögé, majd a töltőképernyő eltűnik.
 * Így az új oldal nem villan fel a töltőképernyő előtt.
 */
const COVER_DELAY = 700; // ennyi ideig takar, mielőtt az új oldal bekerül
const CLOSE_DURATION = 1100; // a töltőképernyő záródó animációja

type Stage = 'LOADING' | 'FINISHING' | 'IDLE';

const RouteTransitionWrapper: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [stage, setStage] = useState<Stage>('LOADING'); // az első betöltésnél is látszik

  const changing = location.key !== displayLocation.key;

  // Első betöltés: rövid töltőképernyő, majd záródás
  useEffect(() => {
    const t = setTimeout(() => setStage('FINISHING'), COVER_DELAY);
    return () => clearTimeout(t);
  }, []);

  // Oldalváltás: takarás -> új oldal behelyezése -> záródás
  useEffect(() => {
    if (!changing) return;
    setStage('LOADING');
    const t = setTimeout(() => {
      setDisplayLocation(location);
      window.scrollTo(0, 0);
      setStage('FINISHING');
    }, COVER_DELAY);
    return () => clearTimeout(t);
  }, [changing, location]);

  // Záródás után eltávolítjuk a töltőképernyőt
  useEffect(() => {
    if (stage !== 'FINISHING') return;
    const t = setTimeout(() => setStage('IDLE'), CLOSE_DURATION);
    return () => clearTimeout(t);
  }, [stage]);

  // Amíg váltás van, mindig takarunk (már az első renderben, nem csak effekt után)
  const showLoader = changing || stage !== 'IDLE';
  const loaderStage = changing || stage === 'LOADING' ? 'LOADING' : 'FINISHING';

  const page = React.isValidElement(children)
    ? React.cloneElement(children as React.ReactElement<any>, { location: displayLocation })
    : children;

  return (
    <>
      {page}
      {showLoader && <LoadingPage stage={loaderStage} />}
    </>
  );
};

export default RouteTransitionWrapper;